// extracted by mini-css-extract-plugin
export default {"root":"KeyThemes_root__3wWNh","btnWrapp":"KeyThemes_btnWrapp__CdmxN","chipsBlock":"KeyThemes_chipsBlock__e9P-d"};